import { render, staticRenderFns } from "./icv2_test_microscope_lg.vue?vue&type=template&id=c77b0b4c"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports